export function HomeSwitch({ on, disabled, label = 'Show in Home', onChange }: {
  on: boolean; disabled?: boolean; label?: string; onChange: (on: boolean) => void;
}) {
  return <button type="button" role="switch" aria-checked={on} aria-label={label}
    disabled={disabled} className="reader-home-switch" onClick={() => onChange(!on)}><span /></button>;
}
